import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: 400;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: #666666;
  width: 100%;
  height: 100%;
  padding: 0 6.25rem;
  overflow: auto;
  text-align: justify;
  padding-bottom: 2.5rem;
  padding-top: 4.5rem;
  gap: 1.5rem;
  &::-webkit-scrollbar {
      width: 0.75rem;
      background: transparent;
      border-radius: 0.5rem;
  }
  &::-webkit-scrollbar-thumb {
      background: #cecece;
      border-radius: 8px;
  }
  @media (max-width: 840px){
    padding: 0 2rem;
  }
`;

export const Divisor = styled.div`
  background: #27284810;
  border-radius: 100px;
  width: 100%;
  min-height: 0.125rem;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 2.25rem;
  line-height: 2.25rem;
  color: #000000;
`;

export const Points = styled.h2`
  font-weight: 600;
  font-size: 2.25rem;
  line-height: 2.25rem;
  color: #000000;
  margin-top: 0.75rem;
  text-align: unset;
`;

export const SubPoint = styled.h3`
  margin-top: 0.5rem;
  font-weight: 600;
  font-size: 1.75rem;
  line-height: 1.75rem;
  color: #000000;
  text-align: left;
`;